import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  // Redirect dacă utilizatorul este deja autentificat
  if (user) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signIn(email, password);
      toast.success('Autentificare reușită!');
      navigate('/admin');
    } catch (err) {
      setError('Email sau parolă incorectă');
      toast.error('Eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box 
      sx={{ 
        minHeight: 'calc(100vh - 200px)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={8} sx={{ p: 4, borderRadius: 3 }}>
        <Box textAlign="center" sx={{ mb: 4 }}>
          <Box
            component="img"
            src="https://psde.md/wp-content/uploads/2025/03/logo.png"
            alt="PSDE Logo"
            sx={{
              height: 60,
              width: 'auto',
              backgroundColor: 'white',
              borderRadius: 2,
              padding: '4px 8px',
              mb: 2,
              display: 'block',
              margin: '0 auto 16px auto'
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Acces Administratori
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Conectează-te pentru a gestiona petițiile PSDE
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ mb: 3 }}
            disabled={loading}
          />
          
          <TextField
            fullWidth
            label="Parolă"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: 4 }}
            disabled={loading}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            sx={{ py: 1.5 }}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Se conectează...
              </>
            ) : (
              'Conectare'
            )}
          </Button>
        </Box>

        <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            <strong>Notă:</strong> Accesul este rezervat doar administratorilor autorizați PSDE. 
            Conturile sunt create și gestionate de echipa tehnică.
          </Typography>
        </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminLogin;
